module.exports = __webpack_public_path__ + "static/ru-logo100-web-c411152f9d9604a11faede9a148ed63d.svg";